import React, {  useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import DashboardHome from "../components/DashboardHome";
import Teams from "../components/Teams";
import AuctionControl from "../components/AuctionControl";
import AuctionLog from "../components/AuctionLog";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import { useTheme } from "../context/ThemeContext";

const GuestDashboard = () => {
  const { gameId } = useParams();
  const { colors, isDark } = useTheme();
  const [activeTab, setActiveTab] = useState("overview");
  const [status, setStatus] = useState(null);
  useEffect(() => {
    // Listen to game status in realtime
    if (!gameId) return;
    const statusRef = ref(db, `games/${gameId}/details/status`);
    const unsubscribe = onValue(statusRef, (snapshot) => {
      if (snapshot.exists()) {
        setStatus(snapshot.val());
      } else {
        setStatus(null);
      }
    }, (error) => {
      console.error("Error listening to game status:", error);
    });

    return () => unsubscribe();
  }, [gameId]);
  return (
    <div className="min-vh-100" style={{ background: colors.background }}>
      {/* Main Content */}
      <div className="container-fluid pt-2 px-4">
        <div className="card shadow-lg border-0" style={{ borderRadius: "20px", overflow: "hidden", background: colors.surface, borderColor: colors.border }}>
                <div className="card-header text-center py-5" style={{ background: colors.surface }}>
                <h1 className="display-4 fw-bold mb-3" style={{ color: colors.text }}>
                  SportsBid Arena - Guest View
                </h1>
                <p className="lead mb-4" style={{ color: colors.textSecondary }}>
                  Watch the auction in real-time. Sign up to participate!
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <Link to="/sign-up" className="btn btn-primary btn-lg px-5 shadow-lg">
                  <i className="bi bi-person-plus me-2"></i>
                  Join Now
                  </Link>
                  <Link to="/sign-in" className="btn btn-outline-primary btn-lg px-5">
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  Login
                  </Link>
                </div>
                </div>

                <div className="card-body p-4" style={{ background: colors.surface }}>
                {/* Tab Navigation */}
            <ul className="nav nav-pills mb-4 justify-content-center" style={{ gap: "10px" }}>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "overview" ? "active" : ""}`}
                  onClick={() => setActiveTab("overview")}
                  style={{
                    borderRadius: "50px",
                    padding: "12px 30px",
                    fontWeight: "600",
                    background: activeTab === "overview" ? colors.primary : "transparent",
                    border: activeTab === "overview" ? "none" : `2px solid ${colors.border}`,
                    color: activeTab === "overview" ? "white" : colors.textSecondary
                  }}
                >
                  <i className="bi bi-info-circle me-2"></i>
                  Overview
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "teams" ? "active" : ""}`}
                  onClick={() => setActiveTab("teams")}
                  style={{
                    borderRadius: "50px",
                    padding: "12px 30px",
                    fontWeight: "600",
                    background: activeTab === "teams" ? colors.primary : "transparent",
                    border: activeTab === "teams" ? "none" : `2px solid ${colors.border}`,
                    color: activeTab === "teams" ? "white" : colors.textSecondary
                  }}
                >
                  <i className="bi bi-shield me-2"></i>
                  Teams & Players 
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "auction" ? "active" : ""}`}
                  onClick={() => setActiveTab("auction")}
                  style={{
                    borderRadius: "50px",
                    padding: "12px 30px",
                    fontWeight: "600",
                    background: activeTab === "auction" ? colors.primary : "transparent",
                    border: activeTab === "auction" ? "none" : `2px solid ${colors.border}`,
                    color: activeTab === "auction" ? "white" : colors.textSecondary
                  }}
                >
                  <i className="bi bi-broadcast me-2"></i>
                  Live Auction
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
              {activeTab === "overview" && (
                <div className="animate-fade-in">
                  <DashboardHome gameId={gameId} />
                </div>
              )}
              
              {activeTab === "teams" && (
                <div className="animate-fade-in">
                  <Teams gameId={gameId} />
                </div>
              )}
              
              {activeTab === "auction" && (
                <div className="row animate-fade-in">
                  <div className="col-lg-8 mb-4">
                    <AuctionControl gameId={gameId} />
                  </div>
                  <div className="col-lg-4 mb-4">
                    { status === "live" ? (<AuctionLog gameId={gameId} />
                    ) : 
                    (<div className="alert" style={{ background: isDark ? colors.backgroundTertiary : colors.info + '20', color: colors.text, border: `1px solid ${colors.border}` }}>
                      <i className="bi bi-info-circle me-2"></i>
                      Auction is not active. Activity log will be available once the auction starts.
                    </div>)}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Call to Action Footer */}
        <div className="text-center py-5" style={{ color: colors.text }}>
          <h3 className="mb-3" style={{ color: colors.text }}>Ready to Host Your Own Auction?</h3>
          <p className="mb-4" style={{ color: colors.textSecondary }}>Create an account and start organizing professional auctions today!</p>
          <Link to="/signup" className="btn btn-primary btn-lg px-5 shadow-lg">
            <i className="bi bi-rocket-takeoff me-2"></i>
            Get Started Free
          </Link>
        </div>
      </div>

      <style jsx>{`
        .animate-fade-in {
          animation: fadeIn 0.5s ease-in;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .nav-link {
          transition: all 0.3s ease;
        }

        .nav-link:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default GuestDashboard;
